import { Stack } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';

interface Props {
  content: JSX.Element;
  'data-testid'?: string;
  paginationComponent?: JSX.Element;
}

export const SearchResultsTableLayoutMobile: FC<Props> = ({
  content,
  paginationComponent,
  ...props
}) => (
  <Stack data-testid={props['data-testid']} alignItems="center">
    {content}
    {paginationComponent}
  </Stack>
);
